import React, { useState, useEffect, forwardRef, isValidElement, cloneElement } from 'react';
import { omit } from '@weareconceptstudio/core';
import { eyeIcon, openEye } from './icons';
import Input from '../Input';
const defaultIconRender = (visible) => (visible ? openEye : eyeIcon);
const actionMap = {
    click: 'onClick',
    hover: 'onMouseOver',
};
const Password = (props) => {
    const { disabled, action = 'click', visibilityToggle = true, iconRender = defaultIconRender } = props;
    const visibilityControlled = typeof visibilityToggle === 'object' && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = useState(() => (visibilityControlled ? visibilityToggle.visible : false));
    useEffect(() => {
        if (visibilityControlled) {
            setVisible(visibilityToggle.visible);
        }
    }, [visibilityControlled, visibilityToggle]);
    const onVisibleChange = () => {
        if (disabled) {
            return;
        }
        setVisible((prevState) => {
            const newState = !prevState;
            if (typeof visibilityToggle === 'object') {
                visibilityToggle.onVisibleChange?.(newState);
            }
            return newState;
        });
    };
    const getIcon = () => {
        const iconTrigger = actionMap[action] || '';
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: 'input-password-icon',
            key: 'passwordIcon',
            onMouseDown: (e) => {
                e.preventDefault();
            },
            onMouseUp: (e) => {
                e.preventDefault();
            },
        };
        return cloneElement(isValidElement(icon) ? icon : React.createElement("span", null, icon), iconProps);
    };
    const suffixIcon = visibilityToggle && getIcon();
    const { className, ...restProps } = props;
    const omittedProps = {
        ...omit(restProps, ['suffix', 'iconRender', 'visibilityToggle']),
        type: visible ? 'text' : 'password',
        suffix: suffixIcon,
    };
    return React.createElement(Input, { ...omittedProps });
};
if (process.env.NODE_ENV !== 'production') {
    Password.displayName = 'InputPassword';
}
export default Password;
//# sourceMappingURL=index.js.map